export default "__VITE_ASSET__nW31GDuy__"